var _circle, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMilestoneIconCompleted(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 128,
    height: 128,
    viewBox: "0 0 128 128",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 64,
    cy: 64,
    r: 60,
    fill: "#002D72",
    stroke: "#50C2CC",
    strokeWidth: 8
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M98.9914 39.0823C97.6038 37.6947 95.7393 37.2178 94.3518 37.2178C92.4873 37.2178 91.0998 38.1428 89.7123 39.5448L60.444 72.9901L39.5443 57.655C38.1567 56.73 36.2922 56.2674 34.4277 56.2674C32.5632 56.73 31.1757 57.655 29.7882 59.057C27.4612 61.8465 28.4006 66.486 31.1757 68.3505L61.8315 91.1148L99.4539 48.3759C100.841 46.9883 101.318 45.1238 101.318 43.2593C100.856 41.8718 100.393 40.4698 98.9914 39.0823Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMilestoneIconCompleted);
export default __webpack_public_path__ + "static/media/milestoneIconCompleted.9fc43732d636c4ac89ffa18dbe168c91.svg";
export { ForwardRef as ReactComponent };